export default {"src":"/_next/static/image/public/images/ic_mypackage_default.d2bec252d3191351018c8851738cb390.svg","height":127,"width":114};